// extracted by mini-css-extract-plugin
export default {"chartHolder":"ChartHolder_chartHolder__-EG18"};